import axios from "axios";
const authInterceptor = (config) => {
  const token = localStorage.getItem("token");
  config.headers["Authorization"] = `Bearer ${token}`;
  config.headers["Content-Type"] = "application/json";
  return config;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API || "https://api-test.dejlah.net/",
  // baseURL: 'https://api.dejlah.net/',
  // baseURL: 'http://192.168.0.82:8000',
});

api.interceptors.request.use(authInterceptor);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Blob requests (the `is_excel` exports) deliver the error body as a Blob,
    // so parse it back to JSON and let callers read `data.errors` as usual.
    const blob = error.response?.data;
    if (blob instanceof Blob && blob.size <= 512 * 1024) {
      try {
        const payload = JSON.parse(await blob.text());
        if (payload && typeof payload === "object") {
          error.response.data = payload;
        }
      } catch {
        // not a JSON payload, keep the original blob
      }
    }

    // eslint-disable-next-line default-case
    switch (error.response?.status) {
      case 401:
        localStorage.removeItem("token");
        window.location.href = "/login";
        break;
    }

    return Promise.reject(error);
  },
);
export default api;
